module.exports = __webpack_public_path__ + "static/search-375e785ce6eb184248754526ce14d7f0.png";